import Code from './Code';
import Result from './Result';


const Home = () => {
    return (
        <>
   
            <Code />
            <Result />
        </>
    )
}

export default Home;